import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutProject44ProfileList extends Layout {
    labelSearchproject44ConfigurationProfiles: Label;
    sourceP44ConfigProfile: DataSource;
    tableP44Profile: Table;
}
